module.exports = __webpack_public_path__ + "static/media/mariposa-03.9f11d6dc.jpg";